import { render, staticRenderFns } from "./OrganizationDetailView.vue?vue&type=template&id=45d86d4c&"
import script from "./OrganizationDetailView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports